module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    attrs: {
      "clearable": "",
      "value": _vm.value,
      "placeholder": "请选择厂商"
    },
    on: {
      "input": _vm.updateValue,
      "clear": function($event) {
        return _vm.updateValue(undefined)
      }
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ed7d928","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/manufacturer/ManufacturerSelect.vue
// module id = 1119
// module chunks = 2